"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactCanWrapper = void 0;
var tslib_1 = require("tslib");
// @ts-ignore
var can_1 = tslib_1.__importDefault(require("can"));
var jquery_1 = tslib_1.__importDefault(require("jquery"));
var React = tslib_1.__importStar(require("react"));
var ReactCanWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(ReactCanWrapper, _super);
    function ReactCanWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapperRef = React.createRef();
        return _this;
    }
    ReactCanWrapper.prototype.componentDidMount = function () {
        var element = this.createElement(this.props.template, this.props.options);
        // tslint:disable-next-line
        this.attachElement(element, this.wrapperRef.current);
    };
    ReactCanWrapper.prototype.componentWillUnmount = function () {
        // tslint:disable-next-line
        this.detachElement(this.wrapperRef.current);
    };
    ReactCanWrapper.prototype.createElement = function (element, options) {
        var template = can_1.default.stache(element);
        return template(options);
    };
    ReactCanWrapper.prototype.attachElement = function (element, node) {
        jquery_1.default(node).append(element);
    };
    ReactCanWrapper.prototype.detachElement = function (element) {
        while (element && element.firstChild) {
            jquery_1.default(element.firstChild).remove();
        }
    };
    ReactCanWrapper.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className || '', ref: this.wrapperRef }));
    };
    return ReactCanWrapper;
}(React.Component));
exports.ReactCanWrapper = ReactCanWrapper;
